import request from '@/utils/request'
let KpsApi = {
    /*地区列表*/
    kpsindex(data, errorback) {
        return request._post('/shop/setting.Region/kpsindex', data, errorback);
    },
}

export default KpsApi;



// WEBPACK FOOTER //
// ./src/api/pei.js